import { HousingCompany, Apartment, InstallationInfo } from "@/models";
import axios from "axios";

export default class HousingCompanyService {
    public async List(): Promise<HousingCompany[]> {
        const companies = (await axios.get("housingcompanies")).data;
        return companies;
    }

    public async GetEmergencyPlanLink(housingCompanyId: number): Promise<string | null> {
        const result = (await axios.get(`housingcompanies/${housingCompanyId}/emergencyplanlink`)).data;
        return result;
    }

    public async GetApartmentList(housingCompanyId: number): Promise<Apartment[] | null> { 
        const result = (await axios.get(`housingcompanies/${housingCompanyId}/apartments`)).data;
        return result;
    }

    public async Get(housingCompanyId: number): Promise<HousingCompany | null> {
        return (await axios.get(`housingcompanies/${housingCompanyId}`)).data;
    }

    public async GetApartment(housingCompanyId: number, apartmentId: number): Promise<Apartment | null> {
        return (await axios.get(`housingcompanies/${housingCompanyId}/apartments/${apartmentId}`)).data;
    }

    public async GetInstallationInfo(housingCompanyId: number): Promise<InstallationInfo | null> {
        return (await axios.get(`housingcompanies/${housingCompanyId}/installationinfo`)).data;
    }
}
